module.exports = __webpack_public_path__ + "img/d1.239c5e25.jpg";